export default __webpack_public_path__ + "static/media/BasicProgramming1.8947ee0d.png";